<script setup lang="ts">
import TopBar from "@/components/blocks/TopBar.vue";
import PageWrap from "@/components/layout/PageWrap.vue";
import { onMounted, watch } from "vue";
import { RouterView, useRoute } from "vue-router";

const APP_NAME = "murnau.rocks";
const route = useRoute();

onMounted(() => {
  document.documentElement.setAttribute(
    "data-theme",
    localStorage.getItem("theme") || "light"
  );
});

watch(
  () => [route.path, route.meta.title],
  () => {
    const page = (route.meta.title as string | undefined) || "";
    document.title = page && route.path !== "/" ? `${page} · ${APP_NAME}` : APP_NAME;
  },
  { immediate: true }
);
</script>

<template>
  <div class="w-full h-full flex flex-col items-stretch">
    <TopBar class="w-full shrink-0" v-if="route.meta.fullScreen !== true" />
    <div
      class="flex min-h-0 w-full flex-1 flex-col"
      :class="route.meta.fill ? 'overflow-hidden' : 'overflow-auto'"
    >
      <PageWrap :gutter="route.meta.bare !== true" :fill="route.meta.fill === true">
        <RouterView />
      </PageWrap>
    </div>
  </div>
</template>

<style scoped></style>
